import api from './axios';

// Action interface
export interface Action {
  id: string;
  name: string;
  description: string;
  tooltip: string;
  command: string;
  parameters: ActionParameter[];
}

// Action parameter interface
export interface ActionParameter {
  name: string;
  type: 'string' | 'number' | 'boolean';
  description: string;
  required: boolean;
  default?: string | number | boolean;
  min?: number;
  max?: number;
}

// Actions response interface
export interface ActionsResponse {
  actions: Action[];
}

// Action execution params interface
export interface ActionExecuteParams {
  actionId: string;
  parameters: Record<string, any>;
  characterId: number;
  characterName: string;
}

// Command response interface
export interface CommandResponse {
  success: boolean;
  message: string;
}

/**
 * Get all available actions
 * @returns Actions response
 */
export const getActions = async (): Promise<ActionsResponse> => {
  const response = await api.get<ActionsResponse>('/actions');
  return response.data;
};

/**
 * Execute an action on a character
 * @param params Action parameters
 * @returns Command response
 */
export const executeAction = async (params: ActionExecuteParams): Promise<CommandResponse> => {
  const response = await api.post<CommandResponse>('/actions', params);
  return response.data;
}; 